import { render, staticRenderFns } from "./SearchResultListPeople.vue?vue&type=template&id=57e2b224&scoped=true&"
import script from "./SearchResultListPeople.vue?vue&type=script&lang=js&"
export * from "./SearchResultListPeople.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultListPeople.vue?vue&type=style&index=0&id=57e2b224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e2b224",
  null
  
)

export default component.exports